import React from 'react';
import { SortableHandle } from 'react-sortable-hoc';
import { Tooltip } from '@material-ui/core';
import { DragIndicator } from '@material-ui/icons';

export const DragHandle = SortableHandle(() => (
  <Tooltip color="primary" title="Hold and drag to sort a Title">
    <DragIndicator />
  </Tooltip>
));
